import Dialog from "dialog";
import template from "./dialog-config-thermostat2l.html";
import css from "./dialog-config-thermostat2l.css";

class ConfigThermostat2lDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-thermostat2l", ConfigThermostat2lDialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.thermostat2l.id;
    this.textboxDeviceStatus.value = devices.thermostat2l.status;
    this.spinnerCurrentPercentage.value = devices.thermostat2l.percentage;
    this.textboxValvueCurrent.value = devices.thermostat2l.valvueCurrent;
	this.textboxHeatingJacketCurrent.value = devices.thermostat2l.heatingJacketCurrent;
    this.textboxHeatingJacketTemperature.value = devices.thermostat2l.heatingJacketTemperature;
    this.textboxBoardTemperature.value = devices.thermostat2l.boardTemperature;    
    this.textboxErrorFlags.value = devices.thermostat2l.errorFlags;    
  }
  buttonClose_click() {
    this.close();
  }
  async spinnerTargetPercentage_change() {
    await server.rcall("RM_thermostat2l_setPWM", this.spinnerTargetPercentage.value);
  }
  async buttonClearErrorFlags_click() {
    await server.rcall("RM_thermostat2l_clearErrorFlags");
  }
  async spinnerPercentage_change() {
    await server.rcall("RM_thermostat2l_setPercentage", this.spinnerPercentage.value);
  }
  async dropdownlistMode_change() {
    await server.rcall("RM_thermostat2l_setMode", this.dropdownlistMode.selectedIndex);
  }
}

ConfigThermostat2lDialog.constructor();

export default ConfigThermostat2lDialog;